<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
                <button mat-icon-button color="primary">
                <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                </button>
            </div>
            <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
                <div class="p-4">
                <p>
                    Registro de vehículos que hacen entregas. 
                    Guarda placa, capacidad y estado. Úsalo para asignar 
                    rutas, planear cargas y controlar disponibilidad.
                </p>
                </div>
            </mat-menu>
            <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Vehículos
            </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Activa/inactiva, crea, actualiza y elimina los <b>vehículos</b> que operan dentro de AVE.
        </div>
      </div>
      <!-- Header -->
      <div
          class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
          <div class="flex shrink-0">
              <!-- Title -->
              <!--<div class="text-3xl font-extrabold tracking-tight">Tipos de Vehiculo</div> -->
              <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[1,0]" [typeFilter]="'master'"
              [selectedStatusesBankType]="selectedStatusesBankType" [showStatusBankType]="true"
                    (selectionFilterApply)="getList()">
                </app-status-filters>
          </div>
          <!-- Actions -->
          <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
              <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'" (click)="onExportButtonPressed()" matTooltip="Exportar">
                  <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
                  <span class="ml-2">Exportar</span>
              </button>
              
              <!-- Add button (only icon) -->
              <button mat-icon-button color="primary" (click)="openModal()" matTooltip="Nuevo Registro">
                  <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
              </button>
          </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
              (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>
              
              <!-- Nombre -->
              <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Nombre</th>
                  <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase">
                    <b class="text-[10px]">{{element.code}}</b><br>
                    {{ element.name }}
                  </td>
              </ng-container>

              <ng-container matColumnDef="businessPartner">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Socio de Negocio - Propietario</th>
                  <td mat-cell *matCellDef="let element" class="leading-tight text-sm">
                    <div *ngIf="getCode(element?.businessPartner) as code">
                      <b class="text-[10px]">{{ code }}</b>
                    </div>
                    <span> {{element?.businessPartner?.name}}</span>
                  </td>
              </ng-container>
              
              <!--Property-->
              <ng-container matColumnDef="ownership">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Propiedad</th>
                  <td mat-cell *matCellDef="let element" class="leading-tight text-sm">
                    {{ element.isOwn ? 'Propio' : 'Externo' }}
                  </td>
              </ng-container>

              <!-- Tipo -->
              <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Tipo</th>
                  <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase">
                      <b class="text-[10px]">{{element.type?.code}}</b><br>
                      {{ element.type?.name }}
                  </td>
              </ng-container>

              <!-- Placa -->
              <ng-container matColumnDef="plate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Placa</th>
                  <td mat-cell *matCellDef="let element" class="text-sm uppercase">
                      {{ element.plate }}</td>
              </ng-container>

              <!-- Company -->
              <ng-container matColumnDef="company">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left">Compañía</th>
                  <td mat-cell *matCellDef="let element" class="text-sm uppercase">
                      <!-- <b>{{element?.company?.id}}</b><br> -->
                      {{ element?.company?.name}}
                  </td>
              </ng-container>

              <!-- Estado -->
              <ng-container matColumnDef="statusId">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Estado</th>
                  <td mat-cell *matCellDef="let element" class="px-6 text-left">
                      <mat-slide-toggle class="custom-slide-toggle primary" [checked]="element.statusId == 1"
                          [(ngModel)]="element.statusId" [color]="'success'"
                          (ngModelChange)="onStatusChange($event, element)">
                      </mat-slide-toggle>
                  </td>
              </ng-container>
  
              <!-- Acciones -->
              <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                  <td mat-cell *matCellDef="let element" class="px-6 py-3 text-left">
                      <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                          <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #actionMenu="matMenu">
                          <button mat-menu-item (click)="openModal(element)">
                              <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                              <span>Editar Registro</span>
                          </button>
                          <button mat-menu-item (click)="openDeleteDialog(element)">
                              <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                              <span>Eliminar Registro</span>
                          </button>
                          <button mat-menu-item (click)="openRoutesModal(element)">
                              <mat-icon svgIcon="heroicons_outline:map-pin"></mat-icon>
                              <span>Rutas asociadas</span>
                          </button>

                          <button mat-menu-item (click)="openTripsModal(element)">
                              <mat-icon svgIcon="heroicons_outline:map"></mat-icon>
                              <span>Viajes asociados</span>
                          </button>
                      </mat-menu>
                  </td>
              </ng-container>
  
              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
  
              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
            </table>
          </div>
          <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo sentimos, no hay registros para mostrar.
          </div>
        </div>
    
        <!-- Paginación debería asignar valor a this.pageSize--> 
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
            <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
                [pageSize]="pageSize"  (page)="changePage($event)"></mat-paginator>
        </div>
      </div>
    </div>
    
    <!-- Modal Agregar y Editar -->
    <ng-template #actionModal>
        <h2 mat-dialog-title class="text-lg font-bold mb-1">{{ (this.id == null ? 'Nuevo' : 'Editar')}} Registro</h2>
        <mat-dialog-content class="modal-content">
            <form #modalForm="ngForm">
                <mat-tab-group>
                    <mat-tab label="Datos Generales">
                        <div class="grid grid-cols-1 gap-y-2 gap-x-4">
                            <app-form-section title="Información Básica" icon="info" iconColor="blue">
                                <div class="grid grid-cols-2 gap-y-2 gap-x-4">
                                    <mat-form-field appearance="fill" class="w-full">
                                        <mat-label>Código</mat-label>
                                        <input matInput [(ngModel)]="currentVechicle.code" name="code" [readonly]="this.id != null"  [disabled]="this.id != null" required>
                                    </mat-form-field>
                                    
                                    @if(this.id == null){
                                    <mat-form-field appearance="fill" class="w-full">
                                        <mat-label>Código Externo</mat-label>
                                        <input matInput [(ngModel)]="currentVechicle.externalKey" name="externalKey" required>
                                    </mat-form-field>
                                    }
            
                                    <mat-form-field appearance="fill" class="w-full">
                                        <mat-label>Nombre</mat-label>
                                        <input matInput [(ngModel)]="currentVechicle.name" name="name" oninput="this.value = this.value.toUpperCase()" required>
                                    </mat-form-field>
            
                                    <mat-form-field appearance="fill" class="w-full">
                                        <mat-label>Marca</mat-label>
                                        <input matInput [(ngModel)]="currentVechicle.brand" name="brand" required>
                                    </mat-form-field>

                                    <mat-form-field appearance="fill" class="w-full">
                                        <mat-label>Placa</mat-label>
                                        <input matInput [(ngModel)]="currentVechicle.plate" name="plate" required>
                                    </mat-form-field>

                                    <mat-form-field appearance="fill" [ngClass]="this.id ? 'col-span-2' : 'w-full'">
                                        <mat-label>Tipos</mat-label>
                                        <mat-select [(ngModel)]="currentVechicle.typeId" name="typeId" required>
                                            @for (type of filteredReasonVehicleTypeList; track type) {
                                            <mat-option [value]="type._id">
                                                {{ type.name }}
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field appearance="fill" class="w-full">
                                        <mat-label>Color</mat-label>
                                        <input matInput [(ngModel)]="currentVechicle.color" name="color" maxlength="50">
                                        <mat-hint *ngIf="currentVechicle.color.length > 49"><b style="font-size: 0.75rem; color: red;">Máximo 50 caracteres</b></mat-hint>
                                    </mat-form-field>                                    

                                    <mat-form-field appearance="fill" class="w-full">
                                        <mat-label>Modelo</mat-label>
                                        <input matInput [(ngModel)]="currentVechicle.model" name="model" maxlength="50">
                                          <mat-hint *ngIf="currentVechicle.model.length > 49"><b style="font-size: 0.75rem; color: red;">Máximo 50 caracteres</b></mat-hint>
                                    </mat-form-field>                                    

                                    <mat-form-field appearance="fill" class="col-span-2">
                                        <mat-label>Descripción</mat-label>
                                        <input matInput [(ngModel)]="currentVechicle.description" name="description" required>
                                    </mat-form-field>
                                </div>
                            </app-form-section>

                            <app-form-section title="Organización y Compañía" icon="business" iconColor="purple">
                                <div class="grid grid-cols-2 gap-y-2 gap-x-4 items-center">
                                    <mat-form-field appearance="fill" class="w-full">
                                        <mat-label>Compañía</mat-label>
                                        <mat-select [(ngModel)]="currentVechicle.companyId" name="company" required>
                                            @for (company of companyFilterList; track company) {
                                            <mat-option [value]="company._id">
                                                {{ company.name }}
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                    <div appearance="fill" class="w-full">
                                        <mat-slide-toggle
                                        [(ngModel)]="currentVechicle.isOwn"
                                        (change)="onChange(currentVechicle.isOwn)"
                                        name="isOwn"
                                        color="primary"
                                    >
                                        ¿Es vehículo propio?
                                    </mat-slide-toggle>
                                    </div>
            
                                    <mat-form-field *ngIf="!currentVechicle.isOwn" appearance="fill" class="w-full">
                                        <mat-label>Socios de Negocio - Propietario</mat-label>
                                        <mat-select [(ngModel)]="currentVechicle.businessPartnerId" name="businessPartnerId">
                                            <mat-option>
                                                <ngx-mat-select-search [(ngModel)]="searchBusiness" [ngModelOptions]="{standalone: true}"
                                                    (ngModelChange)="changueOptionsBusiness($event)" placeholderLabel="Buscar socio..."
                                                    noEntriesFoundLabel="No se encontraron resultados">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (business of businessPartnerList; track business) {
                                            <mat-option [value]="business._id">
                                                <b *ngIf="getCode(business) as code">{{ code }} - </b>{{ business.name }}
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </app-form-section>
                        </div>
                    </mat-tab>

                    <mat-tab label="Dimensiones">
                        <div class="grid grid-cols-1 gap-4">
                            <app-form-section title="Longitud (Distancia)" icon="straighten" iconColor="blue">
                                <div class="grid grid-cols-2 gap-4">
                                    <mat-form-field appearance="fill" class="modal-input">
                                        <mat-label>Altura</mat-label>
                                        <input type="number" matInput [(ngModel)]="currentVechicle.dimensionHeight" name="dimensionHeight" required/>
                                    </mat-form-field>

                                    <mat-form-field appearance="fill">
                                        <mat-label>Ancho</mat-label>
                                        <input type="number" matInput [(ngModel)]="currentVechicle.dimensionWidth" name="dimensionWidth" required/>
                                    </mat-form-field>
                                
                                    <mat-form-field appearance="fill">
                                        <mat-label>Largo</mat-label>
                                        <input matInput type="number" [(ngModel)]="currentVechicle.dimensionLength" name="dimensionLength" required/>
                                    </mat-form-field>

                                    <mat-form-field appearance="fill">
                                        <mat-label>Unidad de Medida</mat-label>
                                        <mat-select [(ngModel)]="currentVechicle.dimensionUnitOfMeasureId" name="dimensionUnitOfMeasureId" required>
                                            <mat-option>
                                                <ngx-mat-select-search [(ngModel)]="searchByGroup[UnitMeasurementGroupEnum.LENGTH]"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (ngModelChange)="searchSubjects[UnitMeasurementGroupEnum.LENGTH].next($event)"
                                                    placeholderLabel="Buscar unidad..." noEntriesFoundLabel="No se encontraron resultados">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                    
                                            @for (unit of unitMeasurementsByGroup[UnitMeasurementGroupEnum.LENGTH]; track unit) {
                                            <mat-option [value]="unit._id">
                                                <b *ngIf="getCode(unit) as code">{{ code }} - </b>{{ unit.name }}
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </app-form-section>
                            <app-form-section title="Peso" icon="fitness_center" iconColor="gray">
                                <div class="grid grid-cols-2 gap-4">
                                    <mat-form-field appearance="fill">
                                        <mat-label>Peso Bruto</mat-label>
                                        <input type="number" matInput [(ngModel)]="currentVechicle.grossWeight" name="grossWeight" required/>
                                    </mat-form-field>
                                    
                                    <mat-form-field appearance="fill">
                                        <mat-label>Peso Neto</mat-label>
                                        <input type="number" matInput [(ngModel)]="currentVechicle.netWeight" name="netWeight" required/>
                                    </mat-form-field>

                                    <mat-form-field appearance="fill">
                                        <mat-label>Unidad de Medida</mat-label>
                                        <mat-select [(ngModel)]="currentVechicle.weightUnitOfMeasureId" name="weightUnitOfMeasureId" required>
                                            <mat-option>
                                                <ngx-mat-select-search [(ngModel)]="searchByGroup[UnitMeasurementGroupEnum.MASS]"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (ngModelChange)="searchSubjects[UnitMeasurementGroupEnum.MASS].next($event)"
                                                    placeholderLabel="Buscar unidad..." noEntriesFoundLabel="No se encontraron resultados">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                    
                                            @for (unit of unitMeasurementsByGroup[UnitMeasurementGroupEnum.MASS]; track unit) {
                                            <mat-option [value]="unit._id">
                                                <b *ngIf="getCode(unit) as code">{{ code }} - </b>{{ unit.name }}
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </app-form-section>
                            <app-form-section title="Volumen" icon="inventory_2" iconColor="green">
                                <div class="grid grid-cols-2 gap-4"> 
                                    <mat-form-field appearance="fill">
                                        <mat-label>Volumen</mat-label>
                                        <input type="number" matInput [(ngModel)]="currentVechicle.volume" name="volume" required/>
                                    </mat-form-field>

                                    <mat-form-field appearance="fill">
                                        <mat-label>Unidad de Medida</mat-label>
                                        <mat-select [(ngModel)]="currentVechicle.volumeUnitOfMeasureId" name="volumeUnitOfMeasureId" required>
                                            <mat-option>
                                                <ngx-mat-select-search [(ngModel)]="searchByGroup[UnitMeasurementGroupEnum.VOLUME]"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (ngModelChange)="searchSubjects[UnitMeasurementGroupEnum.VOLUME].next($event)"
                                                    placeholderLabel="Buscar unidad..." noEntriesFoundLabel="No se encontraron resultados">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                    
                                            @for (unit of unitMeasurementsByGroup[UnitMeasurementGroupEnum.VOLUME]; track unit) {
                                            <mat-option [value]="unit._id">
                                                <b *ngIf="getCode(unit) as code">{{ code }} - </b>{{ unit.name }}
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </app-form-section>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </form>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-actions flex justify-end">
            <button mat-button mat-dialog-close class="align-left">Cancelar</button>
            <button mat-raised-button color="primary" (click)="onSubmit()"
                [disabled]="!modalForm.valid">Guardar</button>
            </mat-dialog-actions>
    </ng-template>

    <ng-template #deleteDialog let-data>
        <div class="flex items-start space-x-2 mb-4">
            <div class="flex items-center">
                <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
                style="font-size: 32px;"></mat-icon>
            </div>
            <div class="grid">
                <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
                <mat-dialog-content class="modal-content mt-0">
                    <p>¿Está seguro que desea eliminar el registro?</p>
                </mat-dialog-content>
            </div>
        </div>
        <mat-dialog-actions class="modal-actions flex justify-end">
            <button mat-button mat-dialog-close class="align-left">Conservar</button>
            <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
        </mat-dialog-actions>
    </ng-template>

    <ng-template #routesModal>
      <app-routes-detail-by-business-partner-vehicle
        [parameterId]="vehicleIdSelected" [typeModal]="'vehicle'" [showTablePrincipal]="false" [showSubRoutes]="true"></app-routes-detail-by-business-partner-vehicle>
    </ng-template>

    <ng-template #tripsModal>
      <app-routes-detail-by-business-partner-vehicle
        [parameterId]="vehicleIdSelected" [typeModal]="'vehicle'" [showTablePrincipal]="false" [showTrips]="true"></app-routes-detail-by-business-partner-vehicle>
    </ng-template>
  </div>  

  <!-- Filtros -->
    <app-filter (onFilterEvent)="getList()" (onCleanEvent)="onClearFilter()" (onPanelOpened)="onFilterPanelOpened()">
        <app-configuration-filters [form]="form" [company]="true" [vehicleType]="true" [loadData]="loadFiltersData"></app-configuration-filters>
        <app-business-partners-filters [form]="form" [businessPartner]="true" [loadData]="loadFiltersData"></app-business-partners-filters>
    </app-filter>
</mat-sidenav-container>